<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    v-on="$listeners"
  >
    <form-builder-shared-field
      v-on:update="updateSharedField(item.name, $event)"
      :loading="false"
      :field-data="field"
      :form-id="id"
      :field-name="item.name"
    />
  </form-builder-editor-field>
</template>

<script>
import { computed } from "vue";
import FormBuilderSharedField from "../atoms/FormBuilderSharedField";
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField, FormBuilderSharedField},

  props: {
    item: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    sharedFields: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    // TODO: unify this with FormBuilderShareField
    const updateSharedField = (fieldName, data) => {
      Object.assign(props.sharedFields[props.item.name], data);
      props.item.displayType = data.sourceFieldType;
      props.item.readOnly = data.readOnly
    }

    const field = computed(() => props.sharedFields[props.item.name])
    return {
      field,
      updateSharedField,
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorSharedField.vue?3fba7861